<template>
    <div>
        <div
            v-if="!editMode"
            class="date-value"
        >
            <span @click="clicked()">{{ value }}</span>
            <kgr-icon-edit @click="clicked()" />
        </div>

        <div
            v-if="editMode"
            class="form-widget without-label date-picker"
            :class="{ invalid: isInvalid }"
        >
            <kgr-date-picker
                :value="value"
                :show-on-init="showOnInit"
                @change="$emit('change', $event)"
                @post-input="onInput"
            />
        </div>
    </div>
</template>

<script>
import DatePicker from '../form/picker/DatePicker.vue';
import IconEdit from '../icon/IconEdit.vue';

export default {
    components: {
        'kgr-date-picker': DatePicker,
        'kgr-icon-edit': IconEdit,
    },
    props: {
        value: {
            type: String,
            required: false,
        },
        editMode: {
            type: Boolean,
            required: false,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            required: false,
            default: false,
        },
        showOnInit: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    watch: {
        editMode(newVal, oldVal) {
            if (!newVal && oldVal) {
                this.$emit('blur');
            }
        },
    },
    methods: {
        clicked() {
            this.$emit('clickToEdit');
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .date-picker {
    max-width: 100px;
    display: inline-block;
    margin-bottom: 5px;
}

.date-value {
    cursor: pointer;
    margin-top: 5px;
    margin-bottom: 10px;
}

.invalid {
    border-color: #f44336;
}
</style>
